module.exports = __webpack_public_path__ + "static/projekt-etykiety-jagiello-20c039974ccfd887e2af157e8533e23b.png";